import dayjs from "dayjs";
import i18n from "@/i18n/index.ts";
import ENexiCharge from "@/struct/nexi-charge/ENexiChargeEnum";
// Helpers di visualizzazione condivisi tra le schermate Addebiti Nexi:
// colori/etichette dei badge e formattazione di importi e date.
export function formatAmount(amount) {
    if (amount === null || amount === undefined || isNaN(Number(amount))) {
        return "—";
    }
    return "€ " + Number(amount).toFixed(2).replace(".", ",");
}
export function formatDate(date) {
    if (!date) {
        return "";
    }
    return dayjs.tz(date, "Europe/Rome").format("DD/MM/YYYY HH:mm");
}
export function chargeStatusColor(status) {
    if (status === ENexiCharge.Status.Ok)
        return "green";
    if (status === ENexiCharge.Status.Error)
        return "red";
    return "grey";
}
export function chargeStatusText(status) {
    if (status === ENexiCharge.Status.Ok)
        return i18n.t("nexi_charge.status.ok");
    if (status === ENexiCharge.Status.Error)
        return i18n.t("nexi_charge.status.error");
    return "";
}
// Testo del dettaglio errore Nexi da mostrare nel tooltip del badge di errore.
// `errore` può essere un oggetto ({ messaggio }), una stringa o null; in fallback usa `esito`.
export function chargeErrorText(errore, esito) {
    if (errore !== null && errore !== undefined && errore !== "") {
        if (typeof errore === "string") {
            return errore;
        }
        if (typeof errore === "object") {
            if (typeof errore.messaggio === "string" && errore.messaggio) {
                return errore.messaggio;
            }
            try {
                return JSON.stringify(errore);
            }
            catch (e) {
                return String(errore);
            }
        }
        return String(errore);
    }
    return esito || "";
}
// Etichetta del motivo di scarto di una riga CSV (errore non bloccante).
export function csvReasonText(reason) {
    const key = "nexi_charge.csv_reason." + reason;
    const translated = i18n.t(key);
    if (translated === key) {
        return i18n.t("nexi_charge.csv_reason.internal_error");
    }
    return translated;
}
// Traduce il codice di errore applicativo nel relativo messaggio utente.
export function errorMessage(code) {
    const key = "nexi_charge.errors." + (code || "internal_error");
    const translated = i18n.t(key);
    // Se la chiave non esiste, vue-i18n restituisce la chiave stessa: fallback generico.
    if (translated === key) {
        return i18n.t("nexi_charge.errors.internal_error");
    }
    return translated;
}
